import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocalStorageService } from '../shared/services/local-storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const localStorageService = inject(LocalStorageService);
  const agency = localStorageService.getItem('agency');

  if (agency) {
    const clonedReq = req.clone({
      setHeaders: {
        'AG-Agency': agency,
      },
    });
    return next(clonedReq);
  }

  return next(req);
};
